"use client"

import { usePathname } from "next/navigation"
import { ReactNode } from "react"

// Client component to check the path
export default function FooterWrapper({ children }: { children: ReactNode }) {
  const pathname = usePathname()

  // If we're on the verification route, return null
  if (pathname?.includes("/verificacion")) {
    return null
  }

  // Otherwise render the children (footer content)
  return <>{children}</>
}
